export default __webpack_public_path__ + "static/media/impactSoft.c2ef093b.svg";